export default __webpack_public_path__ + "static/hcp-hero-no-flowers-66e0e6dc1f7b592211511f73c628e9ff.png";